import { Create, SimpleForm } from 'react-admin';
import { MyFormContainer, MyToolbar } from '@/components/forms';
import { OrgManagerFormFields } from './OrgManagerForm';

export const OrgManagerCreate = () => (
  <Create redirect="list">
    <SimpleForm toolbar={<MyToolbar resource="orgManagers" />}>
      <MyFormContainer>
        <OrgManagerFormFields isCreate />
      </MyFormContainer>
    </SimpleForm>
  </Create>
);

export default OrgManagerCreate;
